import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { saveAs } from 'file-saver'
import { DocumentApi } from '../test-api/index.ts'
import { trackEvent } from '../gtm'
const documentApi = new DocumentApi({}, '/api/v2')
import { useClipboard } from '@vueuse/core'
import { showAlert } from '../components/BcAlert'
import { showConfirm } from '../components/BcConfirm'
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import handleApiError from '../utils/handleApiError'

export default {
  mixins: [
    DocumentStore,
  ],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    showDownloadBtn () {
      if (this.bcDocumentStore?.document?.deleted || this.bcSelectedStore.selectableMap.size === 0 || !this.bcDocumentStore?.document?.can_download) {
        return false
      }

      for (let element of this.bcSelectedStore.selectableMap.values()) {
        if (element.type === 'file' && element.data.can_download) {
          return true
        }
      }

      return false
    },
    isActiveDownloadBtn () {
      if(this.bcSelectedStore.defaultSelected !== false && this.bcSelectedStore.listSelected.length === 0) {
        for (let element of this.bcSelectedStore.selectableMap.values()) {
          if (element.type === 'file' && element.data.can_download && !element.file?.deleted && (element.file && !element.file_upload)) {
            return true
          }
        }
      
      } else if (this.bcSelectedStore.listSelected.length > 0) {
        for (let index = 0; index < this.bcSelectedStore.listSelected.length; index++) {
          const element = this.bcSelectedStore.listSelected[index];
          if (element.type === 'file' && element.data.can_download && !element.file?.deleted && (element.file && !element.file_upload)) {
            return true
          }
        }
      }
      return false
    },
    downloadableFiles() {
      const files = []
      if(this.bcSelectedStore.defaultSelected !== false && this.bcSelectedStore.listSelected.length === 0) {
        this.bcSelectedStore.selectableMap.forEach((element) => {
          if (element.type === 'file' && element.data.can_download && !element.file?.deleted && (element.file && !element.file_upload)) {
            files.push(element)
          }
        })
      } else if(this.bcSelectedStore.listSelected.length > 0) {
        this.bcSelectedStore.listSelected.forEach((element) => {
          if (element.type === 'file' && element.data.can_download && !element.file?.deleted && (element.file && !element.file_upload)) {
            files.push(element)
          }
        })
      }
      return files
    },
    allSelectableFiles() {
      const files = []
      if(this.bcSelectedStore.defaultSelected !== false) {
        this.bcSelectedStore.selectableMap.forEach((element) => {
          if (element.type === 'file' && element.data.can_download && !element.file?.deleted) {
            files.push(element)
          }
        })
      }

      return files;
    },
    antivirNotPassedFiles() {
      return this.downloadableFiles.filter((obj) => {
        return (!obj.file.antivir_ok && !obj.file.antivir_tested)
      })
    },
    antivirInfectedFiles() {
      return this.downloadableFiles.filter((obj) => {
        return obj.file.virus_found
      })
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    async copyZipLink(close) {
      if (!await this.avCheck()) {
        return
      }

      this.loading = true
      close()
      const clipboard = useClipboard()
      let requestZipResponse
      if (this.bcDocumentStore.documentRev) {
        requestZipResponse = await handleApiError(() => documentApi.fileRequestZipDocumentRev(
          this.bcDocumentStore.document.id,
          this.bcDocumentStore.documentRev,
          'original',
          this.allSelectableFiles.length === this.downloadableFiles.length ? [] : this.downloadableFiles.map((e) => e.id)
        ));

      } else if (this.$route.matched[0].name !== 'BCSharedDocument') {
        requestZipResponse = await handleApiError(() => documentApi.fileRequestZipDocument(
          this.bcDocumentStore.document.id,
          'original',
          this.allSelectableFiles.length === this.downloadableFiles.length ? [] : this.downloadableFiles.map((e) => e.id)
        ))
      
      } else {
        requestZipResponse = await handleApiError(() => documentApi.fileRequestZipSharedDocument(
          this.bcDocumentStore.document.id,
          'original',
          this.allSelectableFiles.length === this.downloadableFiles.length ? [] : this.downloadableFiles.map((e) => e.id)
        ))

      }
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'downloadZip', this.bcDocumentStore.document.id)
      clipboard.copy(
        window.location.protocol + '//' + window.location.host + '/api/v2/zip/' + requestZipResponse.data.hash
      )
    },
    async downloadZip() {
      if (!await this.avCheck()) {
        return
      }

      this.loading = true
      if (this.bcDocumentStore.documentRev) {
        const requestZipResponse = await handleApiError(() => documentApi.fileRequestZipDocumentRev(
          this.bcDocumentStore.document.id,
          this.bcDocumentStore.documentRev,
          'original',
          this.allSelectableFiles.length === this.downloadableFiles.length ? [] : this.downloadableFiles.map((e) => e.id)
        ));

        saveAs('/api/v2/zip/' + requestZipResponse.data.hash, requestZipResponse.data.file_name + '.zip')
      } else if (this.$route.matched[0].name !== 'BCSharedDocument') {
        const requestZipResponse = await handleApiError(() => documentApi.fileRequestZipDocument(
          this.bcDocumentStore.document.id,
          'original',
          this.allSelectableFiles.length === this.downloadableFiles.length ? [] : this.downloadableFiles.map((e) => e.id)
        ))

        saveAs('/api/v2/zip/' + requestZipResponse.data.hash, requestZipResponse.data.file_name + '.zip')
      } else {
        const requestZipResponse = await handleApiError(() => documentApi.fileRequestZipSharedDocument(
          this.bcDocumentStore.document.id,
          'original',
          this.allSelectableFiles.length === this.downloadableFiles.length ? [] : this.downloadableFiles.map((e) => e.id)
        ))

        saveAs('/api/v2/zip/' + requestZipResponse.data.hash, requestZipResponse.data.file_name + '.zip')
      }
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'downloadZip', this.bcDocumentStore.document.id)
    },
    async avCheck() {
      if (this.antivirInfectedFiles.length) {
        await showAlert({
          header: this.downloadableFiles > 1
            ? this.$t('Cannot download virus infected files.')
            : this.$t('Cannot download virus infected file.'),
        })
        return false
      }

      if (this.antivirNotPassedFiles.length) {
        return await showConfirm({
          header: this.downloadableFiles > 1
            ? this.$t('Do you really want to download antivir untested files?')
            : this.$t('Do you really want to download antivir untested file?'),
          
          text: this.downloadableFiles > 1
            ? this.$t('Some of the selected files haven\'t been tested with antivirus yet.')
            : this.$t('Selected file haven\'t been tested with antivirus yet.'),
        })
      }

      return true
    },
    async downloadFile() {
      if (!await this.avCheck()) {
        return
      }

      saveAs(this.downloadableFiles[0].file.download_url.original)
      trackEvent(this.$route.matched[0].name, 'downloadFile', this.downloadableFiles[0].file.id)
    },
  }
}